var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoArrowOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13CB45D2-5C1C-4662-93F1-F5846D9CEFAE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25-Sixtbook-Manage_badge_givenListView",
    transform: "translate(-717.000000, -806.000000)",
    fill: "#FF5000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personal-detail",
    transform: "translate(430.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row2",
    transform: "translate(0.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row1",
    transform: "translate(0.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_arrow_out",
    transform: "translate(266.000000, 28.000000) scale(1, -1) translate(-266.000000, -28.000000) translate(257.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,4.41421356 L3.70710678,8.70710678 L2.29289322,7.29289322 L9,0.585786438 L15.7071068,7.29289322 L14.2928932,8.70710678 L10,4.41421356 L10,12.9357 L8,12.9357 L8,4.41421356 L8,4.41421356 Z M16,17.9357 L16,12.9357 L18,12.9357 L18,19.9357 L0,19.9357 L0,12.9357 L2,12.9357 L2,17.9357 L16,17.9357 Z",
    id: "shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowOut);
export default __webpack_public_path__ + "static/media/ico_arrow_out.f93fb1e9c49f258c05f7cef8bf41ec9b.svg";
export { ForwardRef as ReactComponent };